export const envVars = {
  REACT_APP_URL: process.env.REACT_APP_API_URL,
  REACT_APP_DEFAULT_ROUTE: "/key/X9b7K4m2Nq8f5Wz3H7L.html",
};
